import React from 'react';
import './Text.css';

const TeorBelbin = () => {
  return (
    <div className="textinputteor">
      <h1>Роль в коллективе по Белбину</h1>
      
      <p>
        Методология командных ролей по методологии P.M. Белбина — это теоретическая модель ролей в команде и система формирования команд, основанная на том, что команда наиболее эффективна в тех случаях, когда она неоднородна и состоит из людей, обладающих различными способностями, способами мышления и поведения, дополняющих друг друга. Полезными членами для команды являются те, кто обладает качествами и компетенциями, которые необходимы команде и не дублируют характеристики уже существующих членов группы.
      </p>
      
      <p>
        Наивысший балл по результатам тестирования показывает, насколько хорошо участник может исполнять соответствующую роль в команде. Следующий результат после наивысшего балла может обозначать поддерживающую роль, на которую должен переключиться индивид, если его основная командная роль по каким либо причинам не нужна в группе.
      </p>
      
      <h2>Белбин выделяет 8 типов командных ролей:</h2>
      
      <div className="role-card">
        <h3>1. Рабочая пчелка (Company Worker)</h3>
        <p>
          Это человек обычно консервативный и исполнительный, обладающий организаторскими способностями, практичностью, энергичностью, дисциплинированностью, но также недостаточно гибкий, недоверчив к новому.
        </p>
      </div>
      
      <div className="role-card">
        <h3>2. Руководитель (Chairman)</h3>
        <p>
          Спокойный, уверенный в себе, управляемый тип, открыт ко всем мнениям и идеям, крайне мотивирован на достижение поставленных целей, однако часто имеют средние показатели умственных и творческих способностей. Оптимальный тип участника команды для управленческой и руководящей должности.
        </p>
      </div>
      
      <div className="role-card">
        <h3>3. Мотиватор (Shaper)</h3>
        <p>
          Это крайне отзывчивый, динамичный, нервный тип, склонен к недовольству, раздражению и нетерпеливости при этом имеет как внутренний импульс, так и готовность бороться с инертностью, бездеятельностью, самоуспокоенностью или самообманом как всей команды, так и собственной.
        </p>
      </div>
      
      <div className="role-card">
        <h3>4. Генератор идей (Plant)</h3>
        <p>
          Человек, характеризующийся индивидуализмом, серьезностью, нестандартностью, одарен, изобретателен. Обладает как высоким интеллектом, так и знаниями, но часто остается в своем мире, недооценивает практические детали или формальные процедуры.
        </p>
      </div>
      
      <div className="role-card">
        <h3>5. Снабженец (Resource Investigator)</h3>
        <p>
          Экстравертный, увлеченный, пытливый тип. Обладает хорошими коммуникативными навыками и хорошо разрабатывает что-то новое, так в изменяющейся, сложной обстановке продолжает деятельность, несмотря на обстоятельства. Снабженец часто теряет энтузиазм в работе, когда проходит ее первоначальная новизна и интерес.
        </p>
      </div>
      
      <div className="role-card">
        <h3>6. Аналитик (Monitor-Evolution)</h3>
        <p>
          Невозмутимый, предусмотрительный, рассудительный, проницательный, обладает хорошими интеллектуальными способностями, но аналитикам крайне сложно мотивировать других.
        </p>
      </div>
      
      <div className="role-card">
        <h3>7. Вдохновитель (Team Worker)</h3>
        <p>
          Тип командной роли, который характеризуется социальной ориентированностью, спокойным, чувствительным характером. Крайне ответственный, создает и поддерживает настроение в коллективе и настрой, нерешителен при принятии решений. Часто хорошо выступают как лидеры, но не руководители коллектива.
        </p>
      </div>
      
      <div className="role-card">
        <h3>8. Контроллер (Completer-Finisher)</h3>
        <p>
          Это скрупулезный, организованный, добросовестный, социально активный, но перфекционист и эмоционально неустойчивый со стремлением беспокойству тип командной роли.
        </p>
      </div>
      
      <div className="methodology-links">
        <button className="methodology-link">Перейти в Социометрию</button>
      </div>
    </div>
  );
};

export default TeorBelbin;